/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_profile_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set an optional email for display and Gravatar, and choose where your avatar comes from.`)
};

const zh_hans1_settings_profile_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置可选邮箱（仅用于显示与 Gravatar），并选择头像来源。`)
};

const zh_hant1_settings_profile_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定可選的電子郵件（僅用於顯示與 Gravatar），並選擇頭像來源。`)
};

const fr_settings_profile_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définissez un e-mail facultatif pour l’affichage et Gravatar, et choisissez la source de votre avatar.`)
};

const de_settings_profile_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lege optional eine E-Mail für Anzeige und Gravatar fest und wähle, woher dein Avatar kommt.`)
};

const ja_settings_profile_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示用および Gravatar 用の任意のメールアドレスを設定し、アバターの取得元を選択します。`)
};

const ko_settings_profile_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표시 및 Gravatar용 선택적 이메일을 설정하고, 아바타 출처를 선택하세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_profile_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_profile_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_profile_desc", locale)
	if (locale === "en") return en_settings_profile_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_profile_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_profile_desc(inputs)
	if (locale === "fr") return fr_settings_profile_desc(inputs)
	if (locale === "de") return de_settings_profile_desc(inputs)
	if (locale === "ja") return ja_settings_profile_desc(inputs)
	return ko_settings_profile_desc(inputs)
};